<script lang="jsx">
import mixin from '@/plans/mx/shopping-cart';
import { sortBy } from 'lodash';
import AltProratedPlanUser from '@/views/config/shopping-cart/prorated/plan-user.vue';
import AltProratedPlanPrice from '@/views/config/shopping-cart/prorated/plan-price.vue';
import AltProratedPlanPeriod from '@/views/config/shopping-cart/prorated/plan-period.vue';
import { isFromShoppingCart } from '@/views/config/shopping-cart/persist/plan-remove';

export default {
  mixins: [mixin],
  name: 'TranslationInCart',
  computed: {
    hideRemoveAndEditButton() {
      return this.$context.is.editPage || this.$context.is.addPage;
    },
    isShowRemove () {
      if(isFromShoppingCart()) {
        return true;
      }
      return !this.$context.is.editPage && !this.$context.is.addPage;
    }
  },
  components: {
    AltProratedPlanUser,
    AltProratedPlanPrice,
    AltProratedPlanPeriod,
  },
  methods: {
    $renderPrice() {
      if (!this.mx_plans.length) return;
      return (
        <div class="opc-cart-item">
          {sortBy(this.mx_plans, 'participants').map((plan) => {
            return (
              <div>
                {this.mx_title(this.$t('billing.translation_caption.title'), <AltProratedPlanPrice type={plan.type}>{this.$money(this.mx_price(plan))}</AltProratedPlanPrice> )}
                {this.mx_discount(plan.plan_code)}
                {this.mx_cycle(plan.billing_cycle)}
                <AltProratedPlanUser type={plan.type}>
                  {this.mx_new_license(plan, plan.cartInfo.selected_number)}
                </AltProratedPlanUser>
                <AltProratedPlanPeriod type={plan.type} />
                {!this.hideRemoveAndEditButton && this.mx_edit(plan)}
                {this.isShowRemove && this.mx_remove(plan)}
              </div>
            );
          })}
        </div>
      );
    },
    $renderTip() {
      return <div class="opc-cart-item__text"></div>;
    },
  },
};
</script>
